/** The `$id` path param reaches the page as `router.query.id`; an unknown id renders the page's "not found" state in place. */
import { createFileRoute } from '@tanstack/react-router'

import StateFilingsOrderPage from '@/features/state-filings/pages/order-detail'

export const Route = createFileRoute('/_shell/state-filings/orders/$id')({ component: StateFilingsOrderPage })
